module.exports = __webpack_public_path__ + "static/media/card.f65b1de0.svg";